export default "__VITE_ASSET__6530ee5a__"